/** Fuld paragraph med tegn-for-tegn markering — som hastighedstesten. */

interface ParagraphTextDisplayProps {
  text: string;
  cursor: number;
  correctMask: ReadonlyArray<boolean>;
}

export default function ParagraphTextDisplay({
  text,
  cursor,
  correctMask,
}: ParagraphTextDisplayProps) {
  return (
    <div className="rounded-xl bg-zinc-50 p-4 font-mono text-lg leading-relaxed ring-1 ring-zinc-200 dark:bg-zinc-900/60 dark:ring-white/5">
      {text.split('').map((ch, i) => {
        const done = i < cursor;
        const correct = done && correctMask[i];
        const wrong = done && !correctMask[i];
        const active = i === cursor;
        return (
          <span
            key={i}
            className={
              wrong
                ? 'bg-rose-200/80 text-rose-950 dark:bg-rose-500/30 dark:text-rose-100'
                : correct
                  ? 'text-strong'
                  : active
                    ? 'border-b-2 border-indigo-500 text-strong'
                    : 'text-faint'
            }
          >
            {ch}
          </span>
        );
      })}
    </div>
  );
}
